/*
 * @Description 组件 定位监控
 * @Author 
 * @Date 
 */
/* HTML */
<template>
	<!-- index-sub-item start -->
	<div class="index-sub-item sub-item-location">
		<!-- sub-location-box -->
		<div class="sub-item-box sub-location-box">
			<!-- sub-title-box start -->
			<div class="sub-title-box">
				<div class="index-sub-title sub-location-title">定位监控</div>
			</div>
			<!-- sub-title-box end -->
			<!-- sub-location-content start -->
			<div class="sub-location-content">
				
				<!-- 组件 实时定位 -->
				<InTimePosition :hideItemsFlag="true" :hideMileageFlag="true" :hideBsFlag="true" :hideFenceFlag="true" :disallowVideoFlag="true" :showIntoRealFlag="true"/>
				
			</div>
			<!-- sub-location-content end -->
		</div>
		<!-- sub-location-box -->
	</div>
	<!-- index-sub-item end -->
</template>

/* JS */
<script>
	// 引入组件 实时定位
	import InTimePosition from '@/components_pages/Location/InTimePosition';
	
	export default {
		/**
		 * @Des 组件名
		 * @Auth
		 * @Date 
		 */
        name: "IndLocation",
        
        /**
		 * @Des 组件注册
		 * @Auth
		 * @Date 
		 */
        components: {
        	// 组件 实时定位
        	InTimePosition,
        },// components
        
        /**
		 * @Des 属性值
		 * @Auth
		 * @Date 
		 */
        props: {
        	
        },// props
        
        /**
		 * @Des 数据定义
		 * @Auth
		 * @Date 
		 */
		data() {
			return {
				
			}// return
		},// data
		
		/**
		 * @Des 初始化
		 * @Auth
		 * @Date 
		 */
		created() {
			
		},// created
		
		/**
		 * @Des 加载完成
		 * @Auth
		 * @Date 
		 */
		mounted() {
			
		},// mounted
		
		/**
		 * @Des 销毁之前
		 * @Auth
		 * @Date 
		 */
		beforeDestroy() {
			
		},// beforeDestroy
		
		/**
		 * @Des 销毁
		 * @Auth
		 * @Date 
		 */
		destroyed() {
			
		},// destroyed
		
		/**
		 * @Des 方法定义
		 * @Auth
		 * @Date 
		 */
		methods: {
			
		},// methods
		
		/**
		 * @Des 监听
		 * @Auth
		 * @Date 
		 */
		watch: {
			
		},// watch
		
		/**
		 * @Des 实时计算
		 * @Auth
		 * @Date 
		 */
		computed: {
			
		},// computed
		
    }// export default
</script>

/* CSS */
<style lang="scss" scoped>
	
</style>



// WEBPACK FOOTER //
// src/components_index/IndexItems/IndLocation.vue